import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { patch } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";
import { EditTeamProps } from "../../type";

export const editTeam = createAsyncThunk(
  "admin/teams/edit",
    async (params: EditTeamProps, storeActions) => {
    const response: any = await patch(`api/v1/admin/teams/${params.id}`, params, storeActions);
    if (response.status === HttpStatus.OK) {
      return {
        status: response.status,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const editTeamSlice = createSlice({
  name: "editTeamDetails",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as number | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(editTeam.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(editTeam.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(editTeam.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = editTeamSlice.actions;

export default editTeamSlice;
